module.exports = __webpack_public_path__ + "1a228ff585b23f8be6bf4693c7aba90f.png";